/**
 * Fleet CC DCRP Recovery API
 * Connected Claims Damaged Container Recovery APIs used for handling recovery data.
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../../services/encoder';

import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { ShopModel } from '../models/shopModel';

@Injectable()
export class ShopService {
  protected basePath = environment.ccdcrp_api_base_url;
  public defaultHeaders = new HttpHeaders();

  constructor(protected httpClient: HttpClient) {}

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   * Get IEnumerable of ShopModel.
   * Sample request:                    GET                Returns the IEnumerable of distinct regions    This endpoint supports the following HTTP status codes:  - 200 (OK): All shops are successfully retrieved.  - 404 (Not found): liabilityParty are not found.  - 500 (Internal Server Error): An unexpected error occurred while processing the request.
   * @param aPIVersion
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public shopGet(
    aPIVersion?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<string>>;
  public shopGet(
    aPIVersion?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<string>>>;
  public shopGet(
    aPIVersion?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<string>>>;
  public shopGet(
    aPIVersion?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];

    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<string>>(
      'get',
      `${this.basePath}/shop`,
      {
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Get IEnumerable of regions.
   * Sample request:                    GET/regions                Returns the IEnumerable of distinct regions    This endpoint supports the following HTTP status codes:  - 200 (OK): All liabilityParty are successfully retrieved.  - 404 (Not found): liabilityParty are not found.  - 500 (Internal Server Error): An unexpected error occurred while processing the request.
   * @param isFEARecovery isFEARecovery
   * @param aPIVersion
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public shopRegionsGet(
    isFEARecovery?: boolean,
    aPIVersion?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<string>>;
  public shopRegionsGet(
    isFEARecovery?: boolean,
    aPIVersion?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<string>>>;
  public shopRegionsGet(
    isFEARecovery?: boolean,
    aPIVersion?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<string>>>;
  public shopRegionsGet(
    isFEARecovery?: boolean,
    aPIVersion?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (isFEARecovery !== undefined && isFEARecovery !== null) {
      queryParameters = queryParameters.set(
        'isFEARecovery',
        <any>isFEARecovery
      );
    }

    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];

    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<string>>(
      'get',
      `${this.basePath}/shop/regions`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Get IEnumerable of regions.
   * Sample request:                    GET/ShopSearchRequest                Returns the IEnumerable of distinct regions    This endpoint supports the following HTTP status codes:  - 200 (OK): All liabilityParty are successfully retrieved.  - 404 (Not found): liabilityParty are not found.  - 500 (Internal Server Error): An unexpected error occurred while processing the request.
   * @param shopCode
   * @param shopDescription
   * @param regions
   * @param isFeaRecovery
   * @param aPIVersion
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public shopSearchGet(
    shopCode?: string,
    shopDescription?: string,
    regions?: Array<string>,
    isFeaRecovery?: boolean,
    aPIVersion?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<ShopModel>>;
  public shopSearchGet(
    shopCode?: string,
    shopDescription?: string,
    regions?: Array<string>,
    isFeaRecovery?: boolean,
    aPIVersion?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<ShopModel>>>;
  public shopSearchGet(
    shopCode?: string,
    shopDescription?: string,
    regions?: Array<string>,
    isFeaRecovery?: boolean,
    aPIVersion?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<ShopModel>>>;
  public shopSearchGet(
    shopCode?: string,
    shopDescription?: string,
    regions?: Array<string>,
    isFeaRecovery?: boolean,
    aPIVersion?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (shopCode !== undefined && shopCode !== null) {
      queryParameters = queryParameters.set('ShopCode', <any>shopCode);
    }
    if (shopDescription !== undefined && shopDescription !== null) {
      queryParameters = queryParameters.set(
        'ShopDescription',
        <any>shopDescription
      );
    }
    if (regions) {
      regions.forEach((element) => {
        queryParameters = queryParameters.append('Regions', <any>element);
      });
    }
    if (isFeaRecovery !== undefined && isFeaRecovery !== null) {
      queryParameters = queryParameters.set(
        'IsFeaRecovery',
        <any>isFeaRecovery
      );
    }

    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<ShopModel>>(
      'get',
      `${this.basePath}/shop/search`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
